<template>
    <ul class="space-y-6">
        <estimates-old-list-group
            v-for="estimateGroup in groupedEstimates"
            :key="estimateGroup.uuid"
            :estimate-group="estimateGroup"
        ></estimates-old-list-group>
    </ul>
</template>

<script>
import {EstimateOld} from '@models'

export default {
    props: {
      packageId: Number | String,
      compact: Boolean,
      secureOnly: Boolean,
    },
    data () {
        return {
            estimates: [],
        }
    },
    computed: {
        groupedEstimates () {
            // Group estimates by UUID.
          let groupedEstimates = _.groupBy(this.estimates, this.secureOnly ? 'id' : 'uuid')

            // Order each estimate group based on their revision.
            groupedEstimates = _.mapValues(groupedEstimates, (estimates, uuid) => {
                estimates = _.orderBy(estimates, estimate => estimate.id ?? 0, 'desc')

              return {
                uuid,
                estimates,
                latestEstimate: estimates[0],
                otherEstimates: estimates.slice(1),
              }
            })

          if (this.secureOnly) {
            // No need to re-order anything since this is done in the backend
            return groupedEstimates
          }

          // Order the estimate group themselves from newest to oldest.
          return _.orderBy(groupedEstimates, estimateGroup => estimateGroup.id, 'desc')
        },
    },
    methods: {
        async fetchEstimates () {
          if (this.secureOnly) {
            this.estimates = await  EstimateOld.secured(this.packageId)
          } else {
            this.estimates = await  EstimateOld.all(this.packageId)
          }
        },
    },
    mounted () {
        this.fetchEstimates()
    },
}
</script>
